import { render } from "./AllPosts.vue?vue&type=template&id=324b0a0c&scoped=true"
import script from "./AllPosts.vue?vue&type=script&lang=js"
export * from "./AllPosts.vue?vue&type=script&lang=js"

import "./AllPosts.vue?vue&type=style&index=0&id=324b0a0c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-324b0a0c"]])

export default __exports__